import { Link } from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";
import { Container, Nav } from "react-bootstrap";
import logo from "../assets/investifylogo.png";
import { FiArrowRight } from "react-icons/fi";

function Header() {
  return (
    <div className="mb-5">
      <Navbar bg="light" expand="lg" fixed="top" className="p-1">
        <Container>
          <Navbar.Brand>
            <Link to="/">
              <img
                src={logo}
                alt="Investify Logo"
                style={{ width: 250 }}
                className="logo"
              />
            </Link>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />

          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto ms-auto">
              <Link className="nav-link" to="/how-it-works">
                How it works
              </Link>
              <Link className="nav-link" to="/faqs">
                FAQs
              </Link>
              <Link className="nav-link" to="/contact">
                Contact
              </Link>
            </Nav>

            <Nav className="justify-content-end">
              <a
                href="https://app.investify.africa/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <button
                  className="btn btn-success"
                  style={{
                    padding: "10px 20px",
                    fontSize: "0.95rem",
                    fontWeight: "600",
                    borderRadius: "6px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    border: "none",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow =
                      "0 6px 16px rgba(40, 167, 69, 0.4)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow = "none";
                  }}
                >
                  Login / Sign Up <FiArrowRight size={16} />
                </button>
              </a>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}

export default Header;
